export const QTY_MULTIPLY_SYMBOL = "x";
